module.exports = __webpack_public_path__ + "img/15.4a66ac6e.png";